export const SET_THEMATICPAGES_LIST = 'thematicPages/SET_THEMATICPAGES_LIST'
